<section class="mt-3">
  <form [formGroup]="form">
    <div class="form-group">
      <label for="table-name" class="object-label floorplan-builder-label user-select-none">Object name</label>
      <input
        id="table-name"
        type="text"
        formControlName="name"
        placeholder="Enter name"
        class="form-control"
        (change)="nameChange.emit(form.get('name')?.value)"
      >
    </div>

    <div class="form-group mb-2">
      <label class="object-label floorplan-builder-label user-select-none">Rotate object</label>
      <div class="d-flex flex-row align-items-center">
        <div class="d-flex flex-row align-items-center">
          <p class="mb-0 pr-2">ANGLE</p>

          <input
            type="number"
            class="form-control rotation-angle"
            formControlName="rotation"
            placeholder="Enter rotation angle"
            (change)="angleChanged(form.get('rotation'), rotationChange)"
          />
        </div>
        <a (click)="resetAngle();" class="user-select-none">Reset</a>
      </div>
    </div>

    <button *ngIf="isEditMode" class="btn btn-link-danger user-select-none" (click)="delete()">Delete object</button>

    <div class="row pt-2">
      <div class="form-group col">
        <button class="btn btn-info w-100 user-select-none" (click)="saveObject()">{{ isEditMode ? 'Save' : 'Add' }}</button>
      </div>

      <div class="form-group col">
        <button class="btn btn-danger w-100 user-select-none" (click)="cancel()">Cancel</button>
      </div>
    </div>
  </form>
</section>
